module.exports = __webpack_public_path__ + "static/media/collection-feather-getting.7bd60ec4.ogg";